import { useTheme } from '@mui/material';
import { Link } from '@rumblefish/ui/AlgeaTheme';
import React from 'react';
import type { CaseBoxProps } from './CaseBox.types';
import {
  ButtonWrapper,
  StyledButton,
  StyledCompany,
  StyledStack,
  StyledTitle,
} from './styles';

export const CaseBox = ({ company, isActive, link, title }: CaseBoxProps) => {
  const theme = useTheme();

  const companyColor = isActive
    ? theme.palette.blueColors?.PLUS_1
    : theme.palette.invertedContent?.SECONDARY;

  return (
    <StyledStack>
      <StyledCompany variant="strong_400" color={companyColor}>
        {company}
      </StyledCompany>
      <StyledTitle variant="display_xs" isActive={isActive}>
        {title}
      </StyledTitle>

      <ButtonWrapper sx={isActive ? { opacity: 1 } : { opacity: 0 }}>
        <Link to={link}>
          <StyledButton variant="primary">Check it!</StyledButton>
        </Link>
      </ButtonWrapper>
    </StyledStack>
  );
};
